import { el, setAttr } from 'redom';

class ProfilePictureDisplay {

  constructor(configuration = { class: '' }) {

    this.el = el('a.inbox-profile-picture.user-link', {
      class: configuration.class,
      onclick: this.handleClick.bind(this)
    });

  }

  handleClick(event) {

    if (this.el.getAttribute('href') === '#') {
      event.preventDefault();
      event.stopPropagation();
    }

  }

  update(helpSeeker, isInbox) {

    const profilePicture = helpSeeker.profilePicture;

    if (profilePicture === void 0 || profilePicture === null) {
      setAttr(this.el, { style: { 'background-image': 'unset' } });
      this.el.textContent = helpSeeker.initials;
    } else {
      this.el.textContent = '';
      setAttr(this.el, { style: { 'background-image': `url(${profilePicture.url})` } });
    }

    let href = '#';

    if (isInbox === true && typeof helpSeeker._id === 'string') {
      href = `/contacts/${helpSeeker._id}`;
    }

    setAttr(this.el, { href });

  }

}

export default ProfilePictureDisplay;